module.exports = __webpack_public_path__ + "static/img/00288v.e81d309.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Images/00288v.jpg
// module id = V+Sr
// module chunks = 1